import React from 'react';

type TopPanelProps = { children: React.ReactNode };

const TopPanel: React.FC<TopPanelProps> = ({ children }) => {
  return (
    <div className="flex md:flex-row flex-wrap gap-md justify-end shrink-0 flex-col">
      {children}
    </div>
  );
};

export default React.memo(TopPanel) as typeof TopPanel;
